import { createDescendantContext as e } from "./descendant/useDescendant.js";
const [
  t,
  s,
  c,
  o
] = e();
export {
  t as MenuDescendantsProvider,
  o as useMenuDescendant,
  c as useMenuDescendants,
  s as useMenuDescendantsContext
};
//# sourceMappingURL=useMenuDescendantsContext.js.map
